const ufeApi = require('services/api/ufeApi');
const { userXTimestampHeader } = require('utils/Headers');

function gameOptIn(token, { gameId, loyaltyId }) {
    const sdnDomain = Sephora.configurationSettings.sdnDomainBaseUrl;
    const url = `${sdnDomain}/v1/game/${gameId}/user/${loyaltyId}/opt-in`;
    const timeStamp = userXTimestampHeader()['x-timestamp'];

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: {
                'x-source': 'rwd',
                'X-Request-Timestamp': timeStamp,
                authorization: `Bearer ${token}`
            }
        })
        .then(data => data);
}

module.exports = { gameOptIn };
